import { StaffPermission } from 'src/app/core/schemas/staff-permission.schema';
import { SymptomModes } from 'src/app/shared/symptoms/symptom.model';

export interface AssessmentSectionSchema {
  name: string;
  key: string;
  isPreStep?: boolean;
  isFinal?: boolean;
  requiredPermission?: StaffPermission;
}

const STANDARD_SECTIONS: AssessmentSectionSchema[] = [
  { name: 'Link Questionnaire', key: 'linkQuestionnaire', isPreStep: true },
  { name: 'Weather', key: 'weather' },
  { name: 'Medical History', key: 'medicalHistory' },
  { name: 'Medications', key: 'medications' },
  { name: 'Symptoms', key: 'symptoms' },
  { name: 'Signs', key: 'signs' },
  { name: 'Attachments', key: 'attachments' },
  {
    name: 'Impressions & Recommendations',
    key: 'impressionsRecommendations',
    requiredPermission: 'canViewClinicalNotes'
  },
  { name: 'Review & Finalize', key: 'reviewFinalize', isFinal: true }
];

export const NUTRITION_BASED_TESTING_SECTION_KEY = 'nutritionBasedTesting';

const SIGNS_SECTION_INDEX = STANDARD_SECTIONS.findIndex(section => section.key === 'signs');

const SECTIONS_WITH_NUTRITION: AssessmentSectionSchema[] = [
  ...STANDARD_SECTIONS.slice(0, SIGNS_SECTION_INDEX + 1),
  { name: 'Nutrition Based Testing', key: NUTRITION_BASED_TESTING_SECTION_KEY },
  ...STANDARD_SECTIONS.slice(SIGNS_SECTION_INDEX + 1)
];

export const ASSESSMENT_SECTION_SCHEMAS: { [method: string]: AssessmentSectionSchema[] } = {
  [SymptomModes.PreOp]: [
    { name: 'Link Questionnaire', key: 'linkQuestionnaire', isPreStep: true },
    { name: 'Pre-Op', key: 'preOp' },
    { name: 'Review & Finalize', key: 'reviewFinalize', isFinal: true }
  ],
  [SymptomModes.Simple]: [
    { name: 'Link Questionnaire', key: 'linkQuestionnaire', isPreStep: true },
    { name: 'Symptoms', key: 'symptoms' },
    { name: 'Signs', key: 'signs' },
    { name: 'Attachments', key: 'attachments' },
    {
      name: 'Impressions & Recommendations',
      key: 'impressionsRecommendations',
      requiredPermission: 'canViewClinicalNotes'
    },
    { name: 'Review & Finalize', key: 'reviewFinalize', isFinal: true }
  ],
  [SymptomModes.PreOpScreening]: [
    { name: 'Link Questionnaire', key: 'linkQuestionnaire', isPreStep: true },
    { name: 'Medications', key: 'medications' },
    { name: 'Symptoms', key: 'symptoms' },
    { name: 'Signs', key: 'signs' },
    { name: 'Attachments', key: 'attachments' },
    {
      name: 'Impressions & Recommendations',
      key: 'impressionsRecommendations',
      requiredPermission: 'canViewClinicalNotes'
    },
    { name: 'Review & Finalize', key: 'reviewFinalize', isFinal: true }
  ],
  [SymptomModes.Treatment]: [
    { name: 'Link Questionnaire', key: 'linkQuestionnaire', isPreStep: true },
    { name: 'Weather', key: 'weather' },
    { name: 'Medical History', key: 'medicalHistory' },
    { name: 'Medications', key: 'medications' },
    { name: 'Symptoms', key: 'symptoms' },
    { name: 'Signs', key: 'signs' },
    { name: 'Attachments', key: 'attachments' },
    {
      name: 'Impressions & Recommendations',
      key: 'impressionsRecommendations',
      requiredPermission: 'canViewClinicalNotes'
    },
    { name: 'Treatment Performed', key: 'treatmentPerformed' },
    { name: 'Review & Finalize', key: 'reviewFinalize', isFinal: true }
  ],
  [SymptomModes.Advanced]: SECTIONS_WITH_NUTRITION,
  [SymptomModes.FollowUp]: STANDARD_SECTIONS,
  [SymptomModes.Silver]: SECTIONS_WITH_NUTRITION,
  [SymptomModes.DewsIII]: [
    { name: 'OSDI 6', key: 'linkQuestionnaire', isPreStep: true },
    { name: 'Screening', key: 'dewsScreening' },
    { name: 'Medical History', key: 'dewsMedicalHistory' },
    { name: 'Medications', key: 'dewsMedications' },
    { name: 'Signs', key: 'dewsSigns' },
    { name: 'Diagnosis', key: 'dewsDiagnosis' },
    { name: 'Attachments', key: 'attachments' },
    {
      name: 'Impressions & Recommendations',
      key: 'dewsImpressionsRecommendations',
      requiredPermission: 'canViewClinicalNotes'
    },
    { name: 'Review & Finalize', key: 'reviewFinalize', isFinal: true }
  ]
};
